import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import styles from './ResultSlide.css';

function ResultSlide({ title, emoji, description, questions, spriteVersion }) {
    return (
        <div className={styles.card}>
            <p className={styles.label}>Based on your answers, you are:</p>
            <div className={styles.titleSection}>
                <p className={styles.title}>{title} <EmojiIcon name={emoji} version={spriteVersion} className={styles.emoji} /></p>
                <p className={styles.description}>{description}</p>
            </div>
            <div className={styles.divider} />
            <div className={styles.questionsHeader}>
                <Icon name='checkItemFilled' className={styles.checkIcon} />
                <p>Questions written for you:</p>
            </div>
            <ul className={styles.questionsList}>
                {questions.map((question, index) => (
                    <li key={question} className={styles.questionCard}>
                        <span className={styles.badge}>{String(index + 1).padStart(2, '0')}</span>
                        <p>{question}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

ResultSlide.propTypes = {
    title: PropTypes.string.isRequired,
    emoji: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    questions: PropTypes.arrayOf(PropTypes.string).isRequired,
    spriteVersion: PropTypes.string.isRequired
};

export {
    ResultSlide
};
